import React from 'react';

export const SearchIcon = () => (
  <svg height="20.414" viewBox="0 0 20.414 20.414" width="20.414" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M405,405l-6-6m2-5a7,7,0,1,1-7-7A7,7,0,0,1,401,394Z"
      data-name="Path 1178"
      fill="none"
      id="Path_1178"
      stroke="#848a93"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      transform="translate(-386 -386)"
    />
  </svg>
);
